import { defineMessages } from 'react-intl';

export default defineMessages({
    primaryNumber: {
        id: 'driverContactComponent.contact-phone-details.Primary number',
        defaultMessage: 'Primary number'
    }
});